import styles from './index.module.css'
import React from 'react'
import Link from 'components/ui/link'
type Props = {
  breadcrumbs: {
    content: React.ReactNode
    link?: string
  }[]
}

// TODO: replace ui/page-header/breadcrumbs.js with ui/breadcrumbs
// https://disco-team.atlassian.net/browse/DISCO-6914
/**
 * A breadcrumb navigation component that displays a hierarchy of links
 *
 * @param breadcrumbs - Array of breadcrumb items with content and optional links
 * @returns The breadcrumbs component
 */
const Breadcrumbs = ({ breadcrumbs }: Props): React.ReactNode => (
  <div className={styles.breadcrumbs}>
    {breadcrumbs.map(({ content, link }, index) => (
      <>
        <div className={styles.container}>
          {link ? (
            <Link className="text-link" href={link}>
              {content}
            </Link>
          ) : (
            <span>{content}</span>
          )}
        </div>
        {breadcrumbs[index + 1] ? (
          <span className={styles.divider}>/</span>
        ) : null}
      </>
    ))}
  </div>
)

export default Breadcrumbs
